import { http } from '@/support/http'
import { createQuery } from '@/support/utils/paginatorQueryBuilder'
import { parseToFormDataWithArray } from '@/support/payloadParser'

export const getPartnersList = (pagination) => {
  const queryString = createQuery(pagination)

  return http.get(`api/partners?${queryString}`)
}

export const removePartner = (idPartner) => {
  return http.delete(`api/partner/${idPartner}`)
}

export const toggleActivePartner = (idPartner) => {
  return http.post(`api/partner/${idPartner}/toggle`)
}

export const getPartner = (idPartner) => {
  return http.get(`api/partner/${idPartner}`)
}

export const createPartner = (payload) => {
  const form = parseToFormDataWithArray(payload)

  if (payload.image_logo && typeof payload.image_logo === 'object') {
    form.append('image_logo', payload.image_logo, payload.image_logo.name)
  }

  if (payload.image_banner && typeof payload.image_banner === 'object') {
    form.append('image_banner', payload.image_banner, payload.image_banner.name)
  }

  return http.post('api/partner', form, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const updatePartner = (payload) => {
  const form = parseToFormDataWithArray(payload)

  if (payload.image_logo && typeof payload.image_logo === 'object') {
    form.append('image_logo', payload.image_logo, payload.image_logo.name)
  }

  if (payload.image_banner && typeof payload.image_banner === 'object') {
    form.append('image_banner', payload.image_banner, payload.image_banner.name)
  }

  return http.post(`api/partner/${payload.id_partner}`, form, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const getThematicPageTypesList = (pagination) => {
  const queryString = createQuery(pagination)

  return http.get(`showcase/thematic_pages/types?${queryString}`)
}
